import React from 'react';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  // FIX: Replaced the state class property with a constructor to properly initialize state and props, satisfying TypeScript's strict class initialization and making `this.props` available.
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // You can also log the error to an error reporting service
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="w-full max-w-4xl mx-auto my-8 p-6 bg-red-50 border border-red-200 rounded-lg">
          <h1 className="text-3xl font-bold text-red-800">Application Error</h1>
          <p className="mt-2 text-red-700">We're sorry, but something went wrong while loading the application.</p>
          <p className="mt-1 text-red-600">Please try refreshing the page. If the problem persists, please contact support.</p>
          <details className="mt-6 p-4 bg-red-100 rounded">
            <summary className="font-semibold text-red-800 cursor-pointer">Technical Details</summary>
            <pre className="mt-2 text-sm text-red-900 whitespace-pre-wrap break-all">
              {this.state.error?.toString()}
              {'\n\n'}
              {this.state.error?.stack}
            </pre>
          </details>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;